import { CsDateField } from '@/components/Cs/CsDateField'
import { CsField, CsSection } from '@/components/Cs/CsSection'
import { csFieldClass } from '@/components/Cs/csFormStyles'
import { CS_PLANO_ACAO_STATUS, type CsAccountDetail } from '@/services/csService'

type Props = {
  account: CsAccountDetail
  onSave: (payload: Record<string, unknown>) => Promise<void>
}

export function CsAccountRetencao({ account, onSave }: Props) {
  return (
    <CsSection title='Retenção'>
      <CsField label='Risco de churn'>
        <label className='flex items-center gap-2 text-sm text-[var(--text-primary)]'>
          <input
            type='checkbox'
            checked={account.riscoChurn}
            onChange={(e) => void onSave({ riscoChurn: e.target.checked })}
          />
          Conta em risco
        </label>
      </CsField>
      <CsField label='Motivo do risco'>
        <textarea
          className={csFieldClass}
          rows={2}
          defaultValue={account.riscoMotivo ?? ''}
          onBlur={(e) => void onSave({ riscoMotivo: e.target.value || null })}
        />
      </CsField>
      <CsDateField
        label='Data do risco'
        value={account.riscoIdentificadoEm}
        onChange={(value) => void onSave({ riscoIdentificadoEm: value })}
      />
      <CsField label='Plano de ação'>
        <textarea
          className={csFieldClass}
          rows={3}
          defaultValue={account.planoAcao ?? ''}
          onBlur={(e) => void onSave({ planoAcao: e.target.value || null })}
        />
      </CsField>
      <CsField label='Status do plano'>
        <select
          className={csFieldClass}
          value={account.planoAcaoStatus ?? ''}
          onChange={(e) => void onSave({ planoAcaoStatus: e.target.value || null })}
        >
          <option value=''>Sem status</option>
          {CS_PLANO_ACAO_STATUS.map((s) => (
            <option key={s.value} value={s.value}>
              {s.label}
            </option>
          ))}
        </select>
      </CsField>
      <p className='text-xs text-[var(--text-muted)]'>
        Responsável pelo plano: {account.planoAcaoUser?.name ?? account.csm?.name ?? '—'}
      </p>
    </CsSection>
  )
}
